var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import Input from 'components/Input.vue';
let StatisticsHeaderFiltersMenu = class StatisticsHeaderFiltersMenu extends Vue {
    constructor() {
        super(...arguments);
        this.filterGroup = [
            {
                type: 'Checkbox',
                label: 'Status de Contatos',
                items: [
                    { label: 'Não iniciado', value: false },
                    { label: 'Contatados', value: false },
                    { label: 'Interessados', value: false },
                    { label: 'Sucesso', value: false },
                    { label: 'Descartados', value: false },
                ],
            },
            {
                type: 'InputCheckbox',
                label: 'Listas',
                items: [
                    { label: 'Lista 1', value: false },
                    { label: 'Lista 2', value: false },
                    { label: 'Lista 3', value: false },
                    { label: 'Lista 4', value: false },
                ],
            },
            {
                type: 'InputCheckbox',
                label: 'Usuários',
                items: [
                    { label: 'Joao da Silva', value: false },
                    { label: 'Leandro Aguilar', value: false },
                    { label: 'Diogo Publio', value: false },
                    { label: 'Maria Sousa', value: false },
                    { label: 'Renan Oliveira', value: false },
                ],
            },
            {
                type: 'InputCheckbox',
                label: 'Grupo de Setores',
                items: [
                    { label: 'Setor primario', value: false },
                    { label: 'Indústria', value: false },
                    { label: 'Serviços', value: false },
                    { label: 'Varejo', value: false },
                ],
            },
            {
                type: 'InputCheckbox',
                label: 'Localização',
                items: [
                    { label: 'Santo Andre', value: false },
                    { label: 'Santos', value: false },
                    { label: 'Sao Bernardo', value: false },
                    { label: 'Sao Caetano', value: false },
                    { label: 'Pajeu do Piaui', value: false },
                    { label: 'Palmeira do Piaui', value: false },
                    { label: 'Palmeirais', value: false },
                    { label: 'Paqueta', value: false },
                    { label: 'Parnagua', value: false },
                    { label: 'Parnaiba', value: false },
                    { label: 'Paulistana', value: false },
                    { label: 'Picos', value: false },
                ],
            },
        ];
    }
};
StatisticsHeaderFiltersMenu = __decorate([
    Component({
        name: 'StatisticsHeaderFiltersMenu',
        components: {
            Input,
        },
    })
], StatisticsHeaderFiltersMenu);
export default StatisticsHeaderFiltersMenu;
